let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("73AG0")).then(() => parcelRequire('5mAXi'));